import React,{forwardRef } from "react";
import _ from "lodash";
import { BsShare } from "react-icons/bs";
import { FiLink } from "react-icons/fi";
import { PiWarningOctagonLight } from "react-icons/pi";
import { useTranslation } from "react-i18next";
import { useMilestones } from "redux/modules/milestone/hooks";
import Button from "components/button/button";
import LoadingIndicator from "assets/svg/loading-indicator";
import { IoLanguageOutline,IoCodeSlash } from "react-icons/io5";
import { HiOutlinePencilSquare } from "react-icons/hi2";
import { IoCogSharp  } from "react-icons/io5";
import { GoTrash, GoGraph } from "react-icons/go";
import { AnimatePresence, motion } from "framer-motion";
import { LogoBlue } from "constants/images";
import { useHistory } from "react-router-dom";

const OptionListItem = ({
  isYourProfile,
  permission,
  profile = {},
  featured,
  onEdit = () => {},
  onDelete = () => {},
  onReport = () => {},
  onShare = () => {},
  onAnalytics = () => {},
  onCopyLink = () => {},
  share,
  closeModal = () => {},
  closeMoreOption = ()=>{},
  hide = ()=>{},
  translateMilestone = ()=>{},
  group = null,
  setQuickEditId,
  title,
  isMobile,
  detailedView=false,
  tagView=false,
  onRemoveTag=()=>{},
  milestoneEmbed=()=>{},
  ...props
},ref) => {
  const { user_id } = profile;
  const { reports } = featured;
  let checkRerported = null;
  let isLogin = JSON.parse(localStorage.getItem('user_data'));
  const { t, } = useTranslation();
  const {loadingTranslate =false } = useMilestones();
  const history = useHistory();
  
  if (!_.isEmpty(reports)) {
    checkRerported = reports.find((report) => report?.user_id === user_id);
  }

  const handleInputChange = (e)=>{
    translateMilestone(featured,group)
  }

  const ListItem = ()=>{
    if (tagView) {
      return (
        <ul className="">
          <li className="hover:bg-gray hover:rounded-md" {...props}>
            <button
              className="flex flex-row items-center gap-2 text-lg px-6 py-2"
              onClick={() => {
                onRemoveTag();
                closeMoreOption();
                closeModal();
                hide();
              }}>
              <GoTrash />
              {t("removeFromTaggedList", "Remove from my tagged list")}
            </button>
          </li>
        </ul>
      );
    }
    return(
      <ul className="">
          {isYourProfile ||
          (!_.isEmpty(permission) &&
            (permission.status === "owner" ||
              permission.permission.name === "Super Admin" ||
              permission.permission.name === "Admin")) ? (
            <>
            {Boolean(profile?.quick_create_milestone) && detailedView && (
              <li className="hover:bg-gray hover:rounded-t-md" {...props}>
                <button
                  className="flex flex-row gap-2 items-center text-lg px-6 py-2"
                  onClick={() => {
                    setQuickEditId();
                    closeMoreOption();
                    closeModal();
                    hide();
                  }}
                >
                  <HiOutlinePencilSquare />
                  {t("editMilestone")}
                </button>
              </li>
            )}

            <li className="hover:bg-gray hover:rounded-t-md" {...props}>
              <button
                className="flex flex-row gap-2 items-center text-lg px-6 py-2"
                onClick={() => {
                  onEdit();
                  closeMoreOption();
                  closeModal();
                  hide();
                }}
              >
                <IoCogSharp />
                {Boolean(profile?.quick_create_milestone)
                  ? t("advancedEdit")
                  : t("editMilestone")}
              </button>
            </li>
              
              {/*  */}
              {share && (
                <li className="hover:bg-gray hover:rounded-b-md" {...props}>
                  <button
                    className="flex flex-row items-center text-lg px-6 py-2"
                    onClick={()=>{
                      closeMoreOption();
                      onShare(); 
                      hide();
                      }}>
                    <BsShare className="mr-3" />
                    {t('shareMilestone')}
                  </button>
                </li>
              )} 
              <li className="hover:bg-gray hover:rounded-b-md" {...props}>
                <button
                  className="flex flex-row items-center text-lg px-6 py-2"
                  onClick={()=>{
                    closeMoreOption();
                    onCopyLink();
                    closeModal();
                    hide();
                    }}>
                  <FiLink className="mr-3" />
                  {t('copyLink')}
                </button>
              </li>
              <li className="hover:bg-gray hover:rounded-b-md" {...props}>
                <button
                  className="flex flex-row items-center gap-2 text-lg px-6 py-2"
                  onClick={() => {
                    closeMoreOption();
                    console.log("View Analytics");
                    onAnalytics();
                    closeModal();
                    hide();
                  }}>
                  <GoGraph  />
                  {t('viewAnalytics')}
                </button>
              </li> 
              <li className="hover:bg-gray hover:rounded-b-md" {...props}>
                <button
                  className="flex flex-row items-center gap-2 text-lg px-6 py-2"
                  onClick={() => {
                    closeMoreOption();
                    onDelete();
                    closeModal();
                    hide();
                  }}>
                  <GoTrash />
                  {t('deleteMilestone')}
                </button>
              </li> 
            </>
          ) : (
            <>
            {/*  */}
              {
                (!_.isEmpty(isLogin) || !_.isEmpty(profile?.username)) &&
                    <li className="hover:bg-gray hover:rounded-b-md" {...props}>
                      <Button
                        disabled={loadingTranslate}
                        buttonName={
                          <div className="flex gap-2 items-center">
                              <IoLanguageOutline/>
                              <div>{t("translateMilestone")}</div>
                          </div> 
                          }
                        buttonTextClass="text-lg  flex flex-row items-center gap-2"
                        buttonRadius="6px"
                        icon={
                          loadingTranslate ? (
                            <LoadingIndicator className="text-primary w-4 h-4" />
                          ) : null
                        }
                        buttonClass="relative px-6 py-2 bg-white hover:bg-gray hover:rounded-b-md justify-start w-full"
                        onClick={handleInputChange}
                      />
                  </li>
              }
              {share && (
                <li className="hover:bg-gray hover:rounded-b-md" {...props}>
                  <button
                    className="flex flex-row items-center text-lg px-6 py-2"
                    onClick={()=>{
                      closeMoreOption();
                      hide();
                      onShare();
                      }}>
                    <BsShare className="mr-3" />
                    {t('shareMilestone')}
                  </button>
                </li>
              )}
              <li className="hover:bg-gray hover:rounded-b-md" {...props}>
                <button
                  className="flex flex-row items-center text-lg px-6 py-2"
                  onClick={()=>{
                      closeMoreOption();
                      onCopyLink();
                      closeModal();
                      hide();
                    }}>
                  <FiLink className="mr-3" />
                  {t('copyLink')}
                </button>
              </li>
              {
                (!_.isEmpty(isLogin) || !_.isEmpty(profile?.username)) &&
                <li className="hover:bg-gray hover:rounded-md" {...props}>
                  <button
                    onClick={()=>{
                      hide();
                      closeMoreOption();
                      onReport();}}
                    className={`flex flex-row items-center text-lg px-6 py-2 gap-2 ${
                      checkRerported && "bg-gray cursor-not-allowed"
                    }`}
                    disabled={checkRerported ? true : false}>
                    <PiWarningOctagonLight className="text-lg mr-1" />

                    {`${checkRerported ? t('reported') : t('reportMilestone')}`}
                  </button>
                </li>
              }
            
            </>
          )}
          {
            detailedView &&
            <li className="hover:bg-gray hover:rounded-t-md" {...props}>
                <button
                  className="flex flex-row gap-2 items-center text-lg px-6 py-2"
                  onClick={() => {
                    milestoneEmbed();
                    closeMoreOption();
                    closeModal();
                    hide();
                  }}>
                  <IoCodeSlash/>
                  {t("Embed")}
                </button>
              </li>
          }
        </ul>
    )
  }

  return (
    <>
    {
      isMobile ? 
      <MenuBottom title={title} closeMoreOption={closeMoreOption}>
          <ListItem/>
      </MenuBottom>
      : 
      <div className="flex flex-col shadow-lg rounded-md bg-white" ref={ref}>
        <ListItem/>
      </div>
    }
    </>
  );
};

export default forwardRef(OptionListItem);


export const MenuBottom = ({title='',children,closeMoreOption=()=>{}}) =>{
  return (
      <AnimatePresence>
          <div 
            className="fixed z-[999] inset-0 modal-animation"
            aria-labelledby="modal-title"
            role="dialog"
            aria-modal="true"
            >
            <div className="fixed inset-0 bg-black bg-opacity-70 transition-opacity"aria-hidden="true" onClick={closeMoreOption}/>
            <motion.div
                initial={{ y: 50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{  y: -50, opacity: 0 }}
                transition={{ duration: 0.4, ease: "easeInOut" }}
                className="fixed bottom-0 bg-white min-h-[10dvh] w-full rounded-t-lg"
            >
              <div className="border-b border-gray-300 bg-light-gray rounded-t-lg">
                <div className="flex items-center gap-4 px-6 py-4">
                  <div className="">
                    <img src={LogoBlue} alt="logo" className="h-[20px] w-[20px]"/>
                  </div>
                  <div className="text-[12px]">
                    {title}
                  </div>
                </div>
              </div>
            {children}
            </motion.div>
            </div>
        </AnimatePresence>
  )
}
